import { STATUS } from "#candidate/constants"
import CandidateStatusDate from "./CandidateStatusDate"

export default function CandidateStatusRhFilter() {
	return (
		<CandidateStatusDate
			label={"Agendar Entrevista"}
			title="Agendar Entrevista RH"
			status={STATUS.SCHEDULED_BY_HR}
			message="Selecciona la fecha y hora para la entrevista"
		/>
	)
}
